<template>
  <v-container>
    <h2>
      申し込み履歴を確認する
    </h2>
    <br>
    <div class="mb-3 body-2">
      お申込みいただいた内容は、「分析・診断サービス申し込み履歴」画面から内容を確認することができます。
    </div>

    <div class="mt-8 mb-4">
      <v-card  outlined color="teal" class="mx-auto" max-width="90%">
        <v-card-title>
          <v-icon color="white">mdi-phone-forward</v-icon>
          <span class="white--text body-1 font-weight-light">申し込み内容の変更・キャンセルについて</span>          
        </v-card-title>
        <v-card-text class="body-2 white--text">
         お申込み内容について、変更やキャンセルがある場合は、お手数ですがジャパン・アナリストまでご連絡ください。
        </v-card-text>
        <v-btn rounded color="body-2 amber darken-1 font-weight-bold"  @click="openInquiry()" class="mx-2 mb-5">
          <v-icon class="mr-2">mdi-comment-question-outline  </v-icon>ご連絡・お問合わせ
        </v-btn>
      </v-card>
    </div>

    <div class="my-8 mb-4">
      <h3>マイページの表示</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      マイページを表示するために、画面上部の「メニュー」から、「マイページ」を選択します。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-entry-confirm-01.png" width="80%" class="my-2">
    </div>

    <div class="mt-10 mb-4">
      <h3>申し込み履歴を開く</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 mt-4 body-2">
      マイページ画面に分析依頼一覧リストの中から、履歴を確認したいお申込みをクリックします。
    </div>
    <div class="ml-4 mt-4 body-2">
      <img src="/img/man-entry-confirm-02.png" width="95%" class="my-2">
    </div>

    <div class="ml-4 mt-4 body-2">
      申し込み履歴画面が開きます
    </div>
    <div class="ml-4 mb-10 mt-4 body-2">
      <img src="/img/man-entry-confirm-03.png" width="95%" class="my-2">
    </div>

    <div class="mt-10 mb-4">
      <h3>分析サンプルの詳細を開く</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 mt-4 body-2">
      マイページ画面に分析依頼一覧リストの中から、履歴を確認したい申込みをクリックします。
    </div>
    <div class="ml-4 mt-4 body-2">
      <img src="/img/man-entry-confirm-04.png" width="95%" class="my-2">
    </div>
    <div class="ml-4 mt-4 body-2">
      サンプル詳細画面が開きます
    </div>
    <div class="ml-4 mb-10 mt-4 body-2">
      <img src="/img/man-entry-confirm-05.png" width="95%" class="my-2">
    </div>


    <div class="my-4">
      <h3>履歴画面の項目説明</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      お申込み履歴画面の各項目の説明です。
    </div>
    <div class="ml-4 my-4">
      <v-card outlined>
      <v-simple-table v-model="entryData">
        <template v-slot:default>
          <thead>
            <tr style="background-color: grey">
              <th class="text-left white--text">項目名</th>
              <th class="text-left white--text">項目の説明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in entryData" :key="item.name">
              <td class="caption" width="140px">{{ item.name }}</td>
              <td class="caption">{{ item.body }}</td>
            </tr>
          </tbody>
        </template>        
      </v-simple-table>
      </v-card>
    </div>

    <div class="my-4">
      <h3>サンプル詳細画面の項目説明</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      サンプル詳細画面の各項目の説明です。
    </div>
    <div class="ml-4 my-4">
      <v-card outlined>
      <v-simple-table v-model="sampleData">
        <template v-slot:default>
          <thead>
            <tr style="background-color: grey">
              <th class="text-left white--text">項目名</th>
              <th class="text-left white--text">項目の説明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in sampleData" :key="item.name">
              <td class="caption" width="140px">{{ item.name }}</td>
              <td class="caption">{{ item.body }}</td>
            </tr>
          </tbody>
        </template>        
      </v-simple-table>
      </v-card>
    </div>



  </v-container>
</template>
<script>
export default {
    data: () => ({
        buttonName: '',
        entryData: [
          {
            name: 'お申込み状態',
            body: 'お申込みの受付ステータスです。お申込みを受け付ける前は「ご予約中」、受け付けた場合は「受付済み」になります',
          },
          {
            name: '案件名',
            body: 'お申込み時に「案件名」として入力した項目です',
          },
          {
            name: 'お申込日',
            body: 'お申込みいただいた日時です',
          },
          {
            name: 'お申込み担当者',
            body: 'お申込みしていただいた方の氏名です。所属企業、事業所、部署が表示されます',
          },
          {
            name: '受注番号',
            body: 'お申込みを受け付けた際に発行される番号です。お申込みを受け付ける前は「採番待ち」となります。',
          },
          {
            name: '予約番号',
            body: 'お申込みしていただいた際に発行される番号です。',
          },
          {
            name: '分析料金総額',
            body: 'お申込みいただいた分析項目の総合計金額です。表示の金額は標準価格となります。',
          },
          {
            name: '報告書宛先',
            body: '分析結果報告書の宛名です。ここで指定いただいた方の氏名宛てに報告書を作成します',
          },
          {
            name: '報告書送付先',
            body: '分析結果報告書の送付先です。ここで指定いただいた方へ報告書を送付します',
          },
          {
            name: '請求書／納品明細書送付先',
            body: '請求書および納品明細書の送付先です。',
          },
          {
            name: '分析サンプル',
            body: 'お申込みいただいた分析サンプルです。クリックでサンプルの詳細が確認できます。',
          },

        ],
        sampleData: [
          {
            name: 'タイトル',
            body: 'サンプルを採取したマイ機器名が表示されます。',
          },
          {
            name: '機器ID',
            body: 'サンプルを採取したマイ機器IDが表示されます。',
          },
          {
            name: 'オイルメーカー',
            body: 'サンプルを採取したマイ機器のオイルメーカー名が表示されます。',
          },
          {
            name: 'オイル銘柄',
            body: 'サンプルを採取したマイ機器のオイル銘柄が表示されます。',
          },
          {
            name: '分析方法',
            body: 'ご依頼いただいたサンプルの分析方法です',
          },
          {
            name: '分析区分',
            body: 'ご依頼いただいたサンプルの分析区分です',
          },
          {
            name: 'セット分析',
            body: 'ご依頼いただいたサンプルのセット分析名です',
          },
          {
            name: '分析規格',
            body: '報告書へ分析規格の記載を希望いただくと、分析規格名が表示されます。',
          },
          {
            name: '分析項目',
            body: 'ご依頼いただいたサンプルの個別分析名です。この分析項目にはセット分析の項目は含まれません'
          },
          {
            name: '採油日',
            body: 'ご依頼いただいたサンプルの採油日です',
          },
          {
            name: 'ボトル数',
            body: 'ご依頼いただいたサンプルのボトル数です',
          },
          {
            name: 'サンプル量',
            body: 'ご依頼いただいたサンプルのボトル一本あたりのサンプル量です。',
          },
          {
            name: '分析料金',
            body: 'ご依頼いただいたサンプルの分析料金の合計値です。',
          },
          {
            name: '指定納期',
            body: 'ご依頼いただいたサンプルの指定納期です。納期の指定をしていない場合は「指定無し」と表記されます。',
          },
          {
            name: 'フィルター返却',
            body: 'ご依頼いただいたサンプルのフィルター返却の要否です。フィルター返却要の場合はラミネート加工の有無を表示します。',
          },
          {
            name: 'サンプル返却',
            body: 'ご依頼いただいたサンプルの返却要否です。',
          },
        ],
    }),
    methods: {
    }
}
</script>

